import { useEditMode } from '@/contexts/EditModeContext'
import { useLocation } from 'react-router-dom'
import { Pencil, PencilOff } from 'lucide-react'

export default function EditModeToggle() {
  const { isEditMode, toggleEditMode, canEdit } = useEditMode()
  const location = useLocation()

  const isPreviewRoute = location.pathname.startsWith('/teacher/preview/')
  if (!canEdit || !isPreviewRoute) return null

  return (
    <button
      onClick={toggleEditMode}
      title={isEditMode ? 'Salir del modo edición' : 'Activar modo edición'}
      className={`fixed bottom-6 left-6 z-50 flex items-center gap-2 px-4 py-3 rounded-full shadow-lg transition-all hover:scale-105 active:scale-95 ${
        isEditMode
          ? 'bg-amber-500 hover:bg-amber-600 text-white'
          : 'bg-white hover:bg-gray-50 text-gray-700 border border-gray-200'
      }`}
    >
      {isEditMode ? (
        <>
          <PencilOff className="w-5 h-5" />
          <span className="text-sm font-medium">Editando</span>
        </>
      ) : (
        <>
          <Pencil className="w-5 h-5" />
          <span className="text-sm font-medium">Editar</span>
        </>
      )}
    </button>
  )
}
